import type { FolderSide } from "#internal"

import { FolderAt } from "./FolderAt"

/** An edge of the outline left as it is. */
export const FolderStraight: FolderSide = (a, b) => ({
  corners: [FolderAt(a.x, a.y), FolderAt(b.x, b.y)],
  cut: [],
  fold: [],
})
